export default "__VITE_ASSET__TQ7Wd8nF__"